import { reactive, PropType } from 'vue';
import BaseSetupService from '@/setup/BaseSetupService';
import TempWorkerEntity from '@/entity/temp-worker/TempWorkerEntity';

type Props = SetupProps<typeof TempWorkerAvailabilitySetupService.props>

export default class TempWorkerAvailabilitySetupService extends BaseSetupService<Props> {
	static readonly props = {
		readonly: Boolean,
		tempWorker: {
			type: Object as PropType<TempWorkerEntity>,
			required: true as const,
		},
	};

	private readonly state = reactive({ showUnavailabilities: true });

	get showUnavailabilities () { return this.state.showUnavailabilities; }
	set showUnavailabilities (val) { this.state.showUnavailabilities = val; }

	constructor (props?: Props) {
		super(props);
	}
}
